import {
  GetAvailableAppointmentsRequest, GetAvailableAppointmentsResponse,
  IGetAvailableAppointmentsRequest, IGetAvailableAppointmentsResponse
} from "../../compiled";
import {RpcState} from "../RpcState";
import {useState} from "react";
import {useRpcSender} from "../../RpcSender";


export const useGetAppointmentSchedule = () => {
  const rpcSender = useRpcSender();

  const [response, setResponse] = useState<IGetAvailableAppointmentsResponse>();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'pending'});

  const send = (request: IGetAvailableAppointmentsRequest) => {

    setResponse(undefined);
    setRpcState({state: 'pending'});
    rpcSender.send('get_available_appointments',
        GetAvailableAppointmentsRequest.encode(request).finish())
        .then(responseBytes => {
          let response = GetAvailableAppointmentsResponse.decode(responseBytes);
          if (!response.okay) {
            setRpcState({state: 'error', message: "Error loading available times, please try again later."});
            return;
          }

          setResponse(response);
          setRpcState({state: 'success'})
        })
        .catch(e => {
          setRpcState({state: 'error', message: "Network error loading available times, please try again later."});
        })
  }

  return {rpcState, send, response};
}